/* eslint-disable @angular-eslint/no-conflicting-lifecycle */
import { Directive, DoCheck, ElementRef, inject, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { Client } from '@df/core/service/client';
import difference from 'lodash-es/difference';
import { DfsGlobalsService } from '../core/dfs-globals.service';
import { DfsGlobalsServiceFactory } from '../core/dfs-globals.service.factory';
import { NDfs } from '../dfs.interfaces';
import { DfsAtomicService } from './dfs-atomic.service';

type TClassEntries = Record<'default' | 'S' | 'M' | 'L' | 'X', string[]>;

@Directive({
    selector: '[dfs]',
    standalone: true
})
export class DfsDirective implements OnChanges, DoCheck {
    /**
     * Styles definition
     */
    @Input()
    dfs: string | undefined | null | false | (undefined | false | null | string)[];

    /**
     * Parsed classes list
     */
    private classEntries?: TClassEntries;

    private classes: string[] = [];

    private dfsGlobalsService!: DfsGlobalsService;

    private dfsOptions = inject(NDfs.OPTIONS);
    /**
     * Dependencies
     */
    constructor(
        private dfsAtomicService: DfsAtomicService,
        dfsGlobalsServiceFactory: DfsGlobalsServiceFactory,
        private elementRef: ElementRef,
        private client: Client,
        private renderer: Renderer2
    ) {
        this.dfsGlobalsService = dfsGlobalsServiceFactory.get(this.dfsOptions);
        this.renderer.setAttribute(this.elementRef.nativeElement, '_dfs', '');
        this.renderer.setAttribute(this.elementRef.nativeElement, this.dfsGlobalsService.dfsScopeAttr, '');
    }

    /**
     * On changes hook
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['dfs']) {
            try {
                const classEntries = this.getEmptyClassEntries();
                this.dfsAtomicService.parse(this.dfsGlobalsService, this.dfs).forEach(entry => {
                    if (!entry.size) {
                        entry.size = ['default'] as any;
                    }
                    entry.size!.forEach(size => classEntries[size].push(entry.className));
                });
                this.classEntries = classEntries;
            } catch (err) {
                this.classEntries = this.getEmptyClassEntries();
                console.log('dfs error', err, this.elementRef.nativeElement);
            }
        }
    }

    ngDoCheck() {
        this.applyClasses();
    }

    private getEmptyClassEntries(): TClassEntries {
        return { default: [], S: [], M: [], L: [], X: [] };
    }

    private applyClasses() {
        const classes = this.classEntries ? [...this.classEntries.default, ...this.classEntries[this.client.size]] : [];
        difference(this.classes, classes).forEach(className => this.renderer.removeClass(this.elementRef.nativeElement, className));
        difference(classes, this.classes).forEach(className => this.renderer.addClass(this.elementRef.nativeElement, className));
        this.classes = classes;
    }
}
